export default "__VITE_ASSET__DYorebne__"